// TODO Replace with ENDPOINT
const wascApis = "https://apis.wasc.io";

export default async function request({ query, variables }) {
  return fetch(wascApis, {
    method: "post",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  }).then((response) => response.json());
}
